export default __webpack_public_path__ + "static/media/BJ.6056a538.svg";